<template>
    <div v-if="!note.dismissed" class="re-exposures-section">
        <StatusIndicator variant="blue">
            <template #icon>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" class="info-icon">
                    <g clip-path="url(#clip0_11636_967)">
                        <path
                            d="M10 13.3333V9.99996M10 6.66663H10.0084M18.3334 9.99996C18.3334 14.6023 14.6024 18.3333 10 18.3333C5.39765 18.3333 1.66669 14.6023 1.66669 9.99996C1.66669 5.39759 5.39765 1.66663 10 1.66663C14.6024 1.66663 18.3334 5.39759 18.3334 9.99996Z"
                            stroke="currentColor"
                            stroke-width="1.66667"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_11636_967">
                            <rect width="20" height="20" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            </template>
        </StatusIndicator>
        <div class="content">
            <div class="upper">
                <div class="title">
                    <span>Re-Exposures</span>
                    <button type="button" class="dismiss" aria-label="Dismiss the Re-Exposures note" @click="note.dismiss()">
                        <PhX :size="20" aria-hidden="true" />
                    </button>
                </div>
                <p>
                    Your data can resurface periodically. If it does, our system will immediately re-detect and begin the removal
                    process again.
                </p>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { PhX } from '@phosphor-icons/vue';
import StatusIndicator from '~/components/main/shared/StatusIndicator.vue';
import { useReExposuresNoteStore } from '~/stores/person/re-exposures-note';

const note = useReExposuresNoteStore();
</script>

<style lang="scss" scoped>
.re-exposures-section {
    @apply flex gap-4 py-4 pr-4 pl-6 border-t border-zinc-200;
}

.info-icon {
    color: var(--action);
}

.content {
    @apply flex flex-col items-start gap-3 flex-1;
}

.upper {
    @apply flex flex-col gap-0.5 items-start flex-1 w-full;

    p {
        @apply text-zinc-700 text-sm font-normal leading-5;
    }
}

.title {
    @apply flex justify-between items-center w-full;

    span {
        @apply text-zinc-950 text-sm font-semibold leading-5;
    }
}

.dismiss {
    @apply flex rounded text-zinc-700 hover:text-zinc-950;
}

</style>

